module.exports = __webpack_public_path__ + "a7d3b3129756d3ff6d8d9e0e5fc07c7c.svg";